import axios from "axios";
import store from "@/js/store/store";

// 得到url前缀
const service = axios.create({
  // baseURL: '/api',
  baseURL: "",
  timeout: 5000
});

// // 配置axios
// axios.defaults.baseURL = '/api'
// axios.defaults.transformRequest = [function (data) {
//   return Qs.stringify(data)
// }]

// export default{
//   //得到图片文件夹路径，存到web项目下。需要使用虚拟目录
//   getConfig: async function () {
//     getImgFolderConfig();
//     getNewsHost();
//   },
// }

//获取图片文件夹虚拟路径
export async function getImgFolderConfig() {
  //测试环境
  if (process.env.NODE_ENV == "development") {
    store.dispatch(
      "globalConfig/saveImgFolderPath",
      "http://management.haixingjiaxiao.cn/api_image/api/imgFolderPath/"
    );
    store.dispatch(
      "globalConfig/saveResourceFolderPath",
      "http://management.haixingjiaxiao.cn/ResourcePath/"
    );
    store.dispatch(
      "globalConfig/saveSoftwareFolderPath",
      "http://management.haixingjiaxiao.cn/SoftwarePath/"
    );
    store.dispatch(
      "globalConfig/saveEmulatorSoftwareFolderPath",
      "http://management.haixingjiaxiao.cn/EmulatorPath/SoftwareRelease/"
    );
    store.dispatch(
      "globalConfig/saveEmulatorResourceFolderPath",
      "http://management.haixingjiaxiao.cn/EmulatorPath/ResourceRelease/"
    );
    store.dispatch(
      "globalConfig/saveIsEnableUploadEmulatorSoftWare2LocalServer",
      "true"
    );
  }
  //生产环境
  else {
    const res = await service.get("../../static/config/config.json");
    store.dispatch("globalConfig/saveImgFolderPath", res.data.imgFolderPath);
    store.dispatch(
      "globalConfig/saveResourceFolderPath",
      res.data.resourceFolderPath
    );
    store.dispatch(
      "globalConfig/saveSoftwareFolderPath",
      res.data.softwareFolderPath
    );
    store.dispatch(
      "globalConfig/saveEmulatorSoftwareFolderPath",
      res.data.emulatorSoftwareFolderPath
    );
    store.dispatch(
      "globalConfig/saveEmulatorResourceFolderPath",
      res.data.emulatorResourceFolderPath
    );
    store.dispatch(
      "globalConfig/saveIsEnableUploadEmulatorSoftWare2LocalServer",
      res.data.isEnableUploadEmulatorSoftWare2LocalServer
    );
  }
}

//获取websocketurl
export async function getWebSocketUrl() {
  return new Promise(async (resolve, reject) => {
    //测试环境
    if (process.env.NODE_ENV == "development") {
      await store.dispatch(
        "globalConfig/saveWebSocketUrl",
        // "ws://10.14.7.13:9008"
        "wss://wss.yanxiaole.com"
      );
      resolve();
    }
    //生产环境
    else {
      var res = await service.get("../../static/config/config.json");
      await store.dispatch("globalConfig/saveWebSocketUrl", res.data.socketUrl);
      resolve(res);
    }
  });
}

//获取新闻页面host
export async function getNewsHost() {
  const res = await axios.post("/News/GetNewsHost", {});
  store.dispatch("globalConfig/saveNewsHost", res.data.Data).then(res => {
    console.log(res);
    if (res.data.Code == "10000") {
    }
  });
}

//获取过滤敏感词数组
export async function sensitiveWordsArray() {
  const res = await axios.post(
    "/SystemAppSettings/QuerySensitiveWordsArray",
    {}
  );
  store
    .dispatch("systemSetting/saveSensitiveWordsArray", res.data.Data)
    .then(res => { });
}



// WEBPACK FOOTER //
// ./src/js/globalConfig.js